import React from 'react';
import DocsOverviewPage from './docs/DocsOverviewPage';

export default function DocsPage() {
  return <DocsOverviewPage />;
}
